module.exports = __webpack_public_path__ + "img/main.f389882.png";